export default function getRoleName(roleId, roles) {
  if (!roles) {
    return roleId;
  }
  const matchingRole = roles.find(role => role.id === roleId);
  return matchingRole ? matchingRole.name : roleId;
}
